import React, {Fragment, useContext, useRef, useState} from "react";
import {Dialog, Transition} from "@headlessui/react";
import {AuthContext, Button, ErrorMessage, Form, useAPI, ViewContext} from 'components/lib';
import axios from "axios";
import GoogleDrivePickerModal from "./GoogleDrivePickerModal";
import * as orderFromApi from "autoprefixer";
import {useParams} from "react-router-dom";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function ImportFactoryModal(props) {
    const context = useContext(AuthContext);
    const viewContext = useContext(ViewContext);
    const [uploadedDataFile, setUploadedDataFile] = useState(undefined);
    const [ExportSeparatorOption, setExportSeparatorOption] = useState(false);
    const [ExportDelimiter, setExportDelimiter] = useState('');
    const [exportOtherDelimiter, setExportOtherDelimiter] = useState('');
    const [exportQuate, setExportQuote] = useState('');
    const [exportError_ss, setExportError_ss] = useState(false);
    const { orderId, orderItemId } = useParams();


    const cancelButtonRef = useRef(null);
    const [errors, setErrors] = useState([]);
    const [openDrivePicker, setOpenDrivePicker] = useState(false);

    // import realized data from a file picked on Google Drive
    async function importFromDrive(file) {

        const response = await axios.post('/api/driveFile/' + props.orderItemId + '/importRealized', {
            fileId: file.id,
            userId: context.user?.user_id,
            customerId: props.customerId,
            orderID: props.orderItemId,
            standaloneUids: props.isStandalone ? "true" : "false",
            customerOrdersId: props.customerOrdersId,
        });

        const result = response.data;

        if (result.success) {
            if (props.onSuccess) await props.onSuccess();
            props.setOpen(false);
            viewContext.notification.show(
                "Insertion of UID is in progress. We will notify you as soon as it's completed.",
                'success',
                true
            );
        } else {
            props.setOpen(false);
            viewContext.notification.show(result.err || "Upload failed.", 'error', true);
        }
    }


    return (
        <>
        <Transition.Root show={props.open} as={Fragment}>
            <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={props.setOpen}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all mt-12 sm:mt-16 sm:mb-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div>
                                <div className="importFactoryFeature">
                                    <Dialog.Title as="h3" className="text-lg text-center leading-6 font-medium text-gray-900">
                                        Import Factory File
                                    </Dialog.Title>
                                    {errors && errors.length > 0 && <ErrorMessage errors={errors} className={"mt-4"} />}

                                    <div className={"mt-8 mx-8"}>
                                        <div className={"SeparatorOption mb-4"} >
                                            <Form
                                                className={"p-1 bg-white space-y-2 sm:rounded-lg"}
                                                flex={true}
                                                url={`/api/factoryFileUpload/12313/upload/21313`}
                                                method='POST'
                                                buttonTextSm='Upload data file'
                                                updateOnChange={true}
                                                cancel={ e => props.setOpen(false) }
                                                onChange={(e) => {
                                                    if(e.input==='dataFile'){
                                                        setUploadedDataFile(e.value);
                                                    }else{
                                                        if(e.input==='importSeparation'){
                                                            setExportSeparatorOption(e.value);
                                                        }
                                                        else{
                                                            if(e.input==="quate"){
                                                                if(e.value===''){
                                                                    setExportQuote(null);
                                                                }else{
                                                                    if(e.value==="(" || e.value===")"){
                                                                        setExportError_ss(true);
                                                                    }else{
                                                                        setExportError_ss(false);
                                                                    }
                                                                    console.log(e.value)
                                                                    setExportQuote(e.value);
                                                                }
                                                            }else{
                                                                if(e.input==='otherSeperator'){
                                                                    setExportOtherDelimiter(e.value);
                                                                }else{
                                                                    setExportDelimiter(e.value);
                                                                    setExportOtherDelimiter('');
                                                                }

                                                            }
                                                        }
                                                    }

                                                }}
                                                callback={async (s) => {

                                                    const response = s.data || s;
                                                    if (response.success) {
                                                        if (props.onSuccess) {
                                                            await props.onSuccess();
                                                        }
                                                        props.setOpen(false);
                                                        viewContext.notification.show(
                                                            "Insertion of UID is in progress. We will notify you as soon as it's completed.",
                                                            'success',
                                                            true
                                                        );
                                                        // window.location.reload();
                                                    } else {
                                                        props.setOpen(false);
                                                        viewContext.notification.show(response.err || "Upload failed.", 'error', true);
                                                    }

                       
                                                }}
                                                data={{
                                                    dataFile: {
                                                        label: '',
                                                        type: 'file',
                                                        name: 'csvFile',
                                                        required: true,
                                                        value: uploadedDataFile,
                                                        errorMessage: 'Please upload a file',
                                                    },
                                                    importSeparation: {
                                                        label: 'Separator Options',
                                                        type: 'singleCheckbox',
                                                        value: ExportSeparatorOption,
                                                        required: false,
                                                        errorMessage: 'Please select an option',
                                                    },
                                                    separator_ss: {
                                                        type: 'radio',
                                                        options: ["Tab", "Comma", "Semicolon", "Space", "Other"],
                                                        required: false,
                                                        errorMessage: 'Please select an option',
                                                        value:ExportDelimiter,
                                                        label: 'Separated by',
                                                        isHidden: !ExportSeparatorOption,
                                                    },
                                                    otherSeperator: {
                                                        label: '',
                                                        type: 'text',
                                                        value: exportOtherDelimiter,
                                                        isHidden:ExportDelimiter!="Other",
                                                        required: false,
                                                        errorMessage: 'Separated by',
                                                    },
                                                    quate: {
                                                        label: 'String Delimiter',
                                                        type: 'text',
                                                        value: exportQuate,
                                                        required: false,
                                                        isHidden: !ExportSeparatorOption,
                                                        errorMessage: 'Please enter string delimiter',
                                                    },
                                                    userId: {
                                                        label: 'userID',
                                                        type: 'hidden',
                                                        required: true,
                                                        value: context.user?.user_id,
                                                    },
                                                    customerId: {
                                                        label: 'customerId',
                                                        type: 'hidden',
                                                        required: true,
                                                        value: props.customerId,
                                                    },
                                                    orderID: {
                                                        label: 'orderID',
                                                        type: 'hidden',
                                                        required: true,
                                                        value: props.orderItemId,
                                                    },
                                                    standaloneUids: {
                                                        label: 'standaloneUids',
                                                        type: 'hidden',
                                                        value: props.isStandalone,
                                                    },
                                                    customerOrdersId: {
                                                        label: 'customerOrdersId',
                                                        type: 'hidden',
                                                        value: props.customerOrdersId,
                                                    },

                                                }}>
                                            </Form>

                                            <span className="error_ss" style={{display: exportError_ss === true ? 'block' : 'none'}}>Unsupported String Delimeter</span>

                                            <div className="flex items-center my-4">
                                                <div className="flex-grow border-t border-gray-200"></div>
                                                <span className="px-3 text-xs text-gray-400 uppercase tracking-wide"> OR</span>
                                                <div className="flex-grow border-t border-gray-200"></div>
                                            </div>
                                            <Button
                                                text="Choose File From Google Drive"
                                                action={() => setOpenDrivePicker(true)}
                                                small
                                                className="mt-2 w-full bg-orange-500 hover:bg-orange-700 text-white border border-orange-500 font-medium"
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>

        <GoogleDrivePickerModal
            open={openDrivePicker}
            setOpen={setOpenDrivePicker}
            orderItemId={props.orderItemId}
            onPick={importFromDrive}
        />
        </>
    )
}
